import api from "@/plugins/api";

export const fetchNutritionistDetails = async ({ commit }) => {
  const response = await api({
    method: "GET",
    endpoint: "nutritionist"
  });

  const { data } = response;

  commit("nutritionist", data);
};
